import React  from "react";
import {Box} from "@mui/material";

const  CircularProgress = ({image}:any) => {
    return (
        <Box
            style={{ width: '100%', maxWidth: '120px' }}
            component="img"
            sx={{

            }}
            alt="مشکل در لود عکس"
            src={image}
        />
    )
}

export default CircularProgress